<template>
  <div>
    <equipment-edit v-model="tank" title="Tank" :sites="sites"
                    @save="save" :loading="loading" :saving="saving" :dirty.sync="dirty">
      <v-row dense>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input label="Capacity" v-model="tank.capacity" prefix="" suffix="litres" :precision="0" integer/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input label="Tare" v-model="tank.tare" prefix="" suffix="kg" :precision="3"/>
        </v-col>
      </v-row>

      <v-row v-if="connectedToAccounting && values" dense>
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="tank.inventoryAccountRef" label="Inventory asset account"
                          :accounts="accounts" :addTypes="['OtherCurrentAsset']"
                          hint="The inventory account used to track the value of this tank's contents"/>
        </v-col>
      </v-row>

      <v-row v-if="tankId==undefined">
        <v-col cols="12" sm="7">
          <excise-vessel-initial :initial="initial"/>
        </v-col>
      </v-row>
    </equipment-edit>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import {format} from 'date-fns'
import ExciseVesselInitial from '@/views/equipment/exciseVessel/ExciseVesselInitial'
import EquipmentEdit from '@/views/equipment/EquipmentEdit'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'EquipmentTanksEdit',
  mixins: [confirmLeave],
  components: {EquipmentEdit,ExciseVesselInitial},
  props: {
    tankId: {type:String, required:false}
  },
  data () {
    return {
      accounts: [],
      tank: {name:'',active:true,siteId:'',inventoryAccountRef:'',tare:0,capacity:500,
             manufacturer:'',modelNumber:'',serialNumber:'',
             maintenance:{frequency:0,frequencyUnits:'never',nextDate:format(new Date(), 'yyyy-MM-dd'),description:''}},
      initial: {date:format(new Date(), 'yyyy-MM-dd HH:mm:ss'),volume:0,litres:0,kg:0,strength:0,value:0,lot:'',alcoholId:''},
      dirty: false,
      saving: false,
      loading: false
    }
  },
  computed: {
    values() {
      return this.$store.getters.company.permissions.includes('values') && this.$store.getters.company.settings.useAccounts;
    },
    sites() {
      return this.tankId ? null : this.$store.getters.sites(!this.tankId, {B263:true,B265:true,B266:true});
    },
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  },
  async created() {
    this.loading = true;
    const results = await this.$apiCall(`query EquipmentTanksEdit($currency:String!, $accounting:Boolean!, $edit:Boolean!, $id:ID!) {
                                              tank(id:$id) @include(if:$edit) {
                                                id,name,active,capacity,tare,
                                                inventoryAccountRef,pictureURL,
                                                manufacturer,modelNumber,serialNumber,
                                                maintenance {frequency,frequencyUnits,nextDate,description}
                                              }
                                              companyAccounts @skip(if:$edit) {tankInventory}
                                              accounts(currency:$currency) @include(if:$accounting) {
                                                ref,name,type
                                              }
                                          }`,
                                        {accounting:this.connectedToAccounting, currency:this.$store.getters.company.settings.homeCurrency,
                                         edit:this.tankId!=undefined,id:this.tankId || ''});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }

    if (this.connectedToAccounting)
      this.accounts = results.data.accounts.filter(account => account.type === 'OtherCurrentAsset');

    if (this.tankId)
      this.tank = results.data.tank;
    else {
      this.tank.siteId = this.sites[0].id;
      this.tank.inventoryAccountRef = results.data.companyAccounts.tankInventory;
    }
    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },

  methods: {
    async save() {
      this.saving = true;
      // eslint-disable-next-line no-unused-vars
      const {pictureURL,siteId,initial,...input} = this.tank;
      if (!this.tank.id) {
        this.initial.siteId = siteId;
        input.initial = this.initial;
      }
      const results = await this.$apiCall(`mutation EquipmentTanksEdit($input: TankInput!) {
                                             tankCreate(input:$input) {id}
                                           }`,
                                          {input})
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.tank.id?'Updated':'Created'} tank ${this.tank.name}`});
      }
    }
  }
}
</script>